export default function apiResponse(success, data, msg) {
    return {
        success,
        data,
        msg
    };
}



// WEBPACK FOOTER //
// ./src/store/apiResponse.js